import { Radio,Form, Input, Select, Button } from "antd";

import React, { useState,useEffect } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";

import ResumeDbSearchResults from "../resumeDbSearchResults";
import useRDBStore from "../../store/rdb";
import useSettingstore from "../../store/settings.store";
import "./resumeDBSearch.scss";
import { RDB_FILTER_DURATION_OPTIONS, SUPPORTED_LOCATION } from "../../helper/categoryconstants";


export default function ResumeDBSearch() {

    const {rdbPageResult, rdbResumeSearchPerPage ,resetRdbResumeSearchFlag,rdbRefreshResult,resetRdbRefreshResults} =
        useRDBStore();

  const { addOrUpdateSetting, getSettingByKey } = useSettingstore();

  const navigate = useNavigate();
  const location = useLocation();
  const prevValues = location.state?.previousValues ?? {};

  useEffect(() => {
    if (getSettingByKey("rdbSearchView") == null) {
      addOrUpdateSetting({key: "rdbSearchView",value: true,});
    } else if (
      !getSettingByKey("rdbSearchView")?.value &&rdbPageResult != null) {
      navigate("/resultsDB");
    }

  }, []);

  useEffect(() => {
    if (rdbRefreshResult) {
      resetRdbRefreshResults(false);
    }
  }, [rdbRefreshResult]);

  if (!getSettingByKey("rdbSearchView")?.value && rdbPageResult != null) {
    return <Navigate to="/resultsDB" replace />;
  }

  const validValue = (value) => {
    if (value == undefined || value == null || value == "") {
      return false;
    }
    return true;
  };

  const encodeJson = (values) =>{

        let encodedJsonValues ={};

        //console.log("RDB Search Encode", values)         
        var pendingRDBMetaData = JSON.parse(localStorage.getItem("pendingRDBMetaData"))

        //now fill the parameters
        encodedJsonValues.skills=values.skills;
        encodedJsonValues.oskills=values.optkeywords;
        encodedJsonValues.noticeperiod= validValue(values.noticeperiod)?parseInt(values.noticeperiod):1024;
        encodedJsonValues.plocation=values.preferredlocation;           
        encodedJsonValues.minexp= validValue(values.minexp)?parseInt(values.minexp):-1;
        encodedJsonValues.maxexp= validValue(values.maxexp)?parseInt(values.maxexp):-1;
        encodedJsonValues.pagenum= 1; //starts with first page
        encodedJsonValues.maxresumespp= 10;
        encodedJsonValues.duration = validValue(values.duration)?values.duration:24;

        encodedJsonValues.filter ={};
        encodedJsonValues.filter.minctc = validValue(values.minctc)?parseFloat(values.minctc):-1;
        encodedJsonValues.filter.maxctc = validValue(values.maxctc)?parseFloat(values.maxctc):-1;
        encodedJsonValues.filter.clocation = validValue(values.clocation)?values.clocation:"Any";
        //encodedJsonValues.filter.workmode = values.workmode
        encodedJsonValues.filter.lwdstatus= validValue(values.lwdstatus)?values.lwdstatus:"Any";

        encodedJsonValues.pendingRDBMetaData = pendingRDBMetaData
        localStorage.setItem("pendingRDBMetaData", JSON.stringify([]));

        return encodedJsonValues
  }

  const handleFormSubmit = (values) => {
    var duration = validValue(values.duration)?values.duration:"24";   
    values.duration = duration  
    const jasonValues = encodeJson(values);
    
    addOrUpdateSetting({key: "resumeDB",value: JSON.stringify(jasonValues),});
    addOrUpdateSetting({key: "rdbSearchView",value: false,});

    resetRdbResumeSearchFlag();
    rdbResumeSearchPerPage(jasonValues, duration);
    navigate("/resultsDB");
  };
  const searchData = 
    {
      minctc:  prevValues?.filter?.minctc,
      maxctc: prevValues?.filter?.maxctc, 
      minexp: prevValues?.minexp, 
      maxexp: prevValues?.maxexp,              
      skills: prevValues?.skills,  
      noticeperiod: prevValues.noticeperiod,             
      lwdstatus: prevValues?.filter?.lwdstatus,                                                     
      preferredlocation: prevValues?.plocation,
      clocation: prevValues?.filter?.clocation,      
      duration:prevValues?.duration,
  };
  return (
    <div className="resumeDBSearch-list-wrapper">
      <p className="resumeDB-title">Search Resumes from QHR Flow DataBase</p>
      <Form
        className="jd-creation-form"
        name="jd-creation-form"
        justify="start"
        layout="vertical"
        autoComplete="off"
        initialValues={searchData}
        onFinish={handleFormSubmit}
      >
        <Form.Item
          required={true}
          name="skills"
          className="jd-creation-field-item"
          label="Mandatory Keywords"
        >
          <Input required={true} className="jd-creation-input" />
        </Form.Item>

        <div className="dual-input-wrapper">
          <Form.Item
            className="jd-creation-field-item"
            label="Experience Range ( Min - Max ) Yrs "
          >
            <div className="jd-creation-field-min-max-inputs">
              <Form.Item
                className="jd-creation-field-item"
                name="minexp"
              >
                <Input
                  name="minexp"
                  type="number"
                  className="jd-creation-input"
                />
              </Form.Item>              
              <Form.Item
                className="jd-creation-field-item"
                name="maxexp"
              >
              <Input
                name="maxexp"
                type="number"
                className="jd-creation-input"
              />
              </Form.Item>  
            </div>
          </Form.Item>
          <Form.Item
            className="jd-creation-field-item"
            label="CTC Range ( Min - Max ) LPA "
          >
            <div className="jd-creation-field-min-max-inputs">
              <Form.Item
                  className="jd-creation-field-item"
                  name="minctc"
              >
                <Input
                  name="minctc"
                  type="number"
                  className="jd-creation-input"
                />
              </Form.Item>
              <Form.Item
                  className="jd-creation-field-item"
                  name="maxctc"
              >
                <Input
                  name="maxctc"
                  type="number"
                  className="jd-creation-input"
                />
              </Form.Item>
            </div>
          </Form.Item>          
        </div>

        <div className="dual-input-wrapper">
          <Form.Item
            className="jd-creation-field-item"
            label="Notice Period (In Days)"
            name="noticeperiod"
          >
            <Input type="number" className="jd-creation-input" />
          </Form.Item>          
          <Form.Item
            name="lwdstatus"
            className="jd-creation-field-item"
            label="LWD Status"
          >
            <Radio.Group className="jd-creation-radio-wrapper">
              <Radio className="radio-option" value={"Current Month"}>
                Current Month
              </Radio>
              <Radio className="radio-option" value={"Next Month"}>
                Next Month
              </Radio>
              <Radio className="radio-option" value={"Expired"}>
                Expired
              </Radio>
              <Radio className="radio-option" value={"Any"}>
                Any
              </Radio>  
              <Radio className="radio-option" value={"Not Resigned"}>
                Not Resigned
              </Radio>                           
            </Radio.Group>
          </Form.Item>
        </div>

        <div className="dual-input-wrapper">
          <Form.Item
            name="clocation"
            className="jd-creation-field-item"
            label="Current Location"
          >
            <Select
                className="jd-creation-input"                            
                options={SUPPORTED_LOCATION}
            />             
          </Form.Item>
          <Form.Item
            name="preferredlocation"
            className="jd-creation-field-item"
            label="Perferred Location"
          >
            <Select
                className="jd-creation-input"                            
                options={SUPPORTED_LOCATION}
            /> 
          </Form.Item>
        </div>
        <Form.Item
          name="duration"
          className="jd-creation-field-item"
          label="Uploading Period"
        >
          <Select
            className="jd-creation-input"
            defaultValue={"24"}
            options={RDB_FILTER_DURATION_OPTIONS}
          />
        </Form.Item>
        <Button
          className="resumeDb-submit-button"
          type="primary"
          htmlType="submit"
        >
          Search
        </Button>
      </Form>
    </div>
  );
}
